import React, { Component, useState, useEffect } from "react";
import RoadmapCard from "./RoadmapCard.jsx";
import CollectionCard from "../CollectionCard.jsx";
import CollectionAddToModal from "../CollectionAddToModal.jsx";
import ReactModalParser from "../ReactModalParser.jsx";
const View = ({ roadmapLoading, RoadmapData, dashboardMode }) => {
  const [roadmapViewMode, setRoadmapViewMode] = useState("starred");
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [currentRmap, setCurrentRmap] = React.useState({});
  const RoadmapView = () => {
    if (roadmapLoading) {
      return <div>loading, I'm slow!</div>;
    } else {
      return (
        <React.Fragment>
          <ReactModalParser
            isOpen={modalIsOpen}
            closeModal={() => {
              setIsOpen(false);
            }}
          >
            <CollectionAddToModal />
          </ReactModalParser>

          <div className="RoadmapsFlexContainer">
            {RoadmapData[roadmapViewMode].map((eachRoadmap, i) => {
              return (
                <RoadmapCard
                  props={eachRoadmap}
                  roadmapViewMode={roadmapViewMode}
                  key={i}
                  setIsOpen={setIsOpen}
                  setCurrentRmap={setCurrentRmap}
                />
              );
            })}
          </div>
        </React.Fragment>
      );
    }
  };
  const CollectionView = () => {
    return (
      <div className="CollectionsFlexContainer">
        {[0, 0, 0].map((eachUh, i) => {
          return <CollectionCard />;
        })}
      </div>
    );
  };

  const RoadmapNavbar = () => {
    return (
      <div className="DBNavbar">
        <div
          className="DBNavbarItems"
          onClick={() => {
            setRoadmapViewMode("starred");
          }}
        >
          Starred
        </div>
        <div
          className="DBNavbarItems"
          onClick={() => {
            setRoadmapViewMode("created");
          }}
        >
          Created
        </div>
        <div
          className="DBNavbarItems"
          onClick={() => {
            setRoadmapViewMode("drafted");
          }}
        >
          Draft
        </div>
      </div>
    );
  };

  switch (dashboardMode) {
    case "roadmapView":
      return (
        <React.Fragment>
          <RoadmapNavbar />
          <RoadmapView />
        </React.Fragment>
      );
    case "profileView":
      return <div>profile</div>;
    case "statisticsView":
      return <div>statistics</div>;

    case "collectionView":
      return (
        <React.Fragment>
          <CollectionView />
        </React.Fragment>
      );
  }
};

export default View;
